/** "The session, directly" -> "the-session-directly": the id a heading gets, for links. */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Second-level headings of a document, in order, for a table of contents. Fenced code is
 * skipped, so a `## comment` inside a snippet is not a section.
 */
export function outline(markdown: string): { id: string; title: string }[] {
  const headings: { id: string; title: string }[] = [];
  let fenced = false;
  for (const line of markdown.split("\n")) {
    if (line.startsWith("```")) fenced = !fenced;
    if (fenced) continue;
    const match = /^## (.+)$/.exec(line);
    if (match) {
      const title = match[1].replace(/`/g, "").trim();
      headings.push({ id: slugify(title), title });
    }
  }
  return headings;
}
